import * as React from 'react';
import { ThemeClassNameContext, ProviderContext } from '@fluentui/react-shared-contexts';

function useFluentThemeClassName() {
    const { targetDocument = window.document } = React.useContext(ProviderContext);
    const className = React.useContext(ThemeClassNameContext);
    React.useLayoutEffect((): void | (() => void) => {
        if (className) {
            targetDocument.documentElement.classList.add(className);

            return () => {
                targetDocument.documentElement.classList.remove(className);
            };
        }
    }, [targetDocument, className]);
}

export function FluentThemeWrapper({ children }: React.PropsWithChildren<{}>) {
    useFluentThemeClassName();
    return <>{children}</>;
}
